import { Heading, Text } from '@components/ui/typography';
import { parse } from '@config/theme';
import React, { FC } from 'react';
type ChangelogPageIntroProps = {
  title: string;
  text: string;
  lastUpdateDate: string;
};
export const ChangelogPageIntro: FC<ChangelogPageIntroProps> = ({
  title,
  text,
  lastUpdateDate
}) => {
  const d = new Date(lastUpdateDate);
  const day = d.toLocaleDateString('us', {
    day: 'numeric'
  });
  const month = d.toLocaleDateString('us', {
    month: 'short'
  });
  const year = d.toLocaleDateString('us', {
    year: 'numeric'
  });
  const date = `${month} ${day}, ${year}`;
  return <div className={content}>
      <Heading variant="h2" as="h1" mb="24">
        {title}
      </Heading>
      <Text variant="bodyLarge" color="shade500" mb="24" mx="auto" style={{
      maxWidth: 744
    }}>
        {text}
      </Text>
      <Text variant="bodyLarge" className={gradient}>
        Last updated: {date}
      </Text>
    </div>;
};
const content = parse({
  textAlign: 'center',
  py: {
    _: '56',
    sm: '80',
    md: '88'
  },
  mb: {
    _: '56',
    sm: '80',
    md: '88'
  }
}, "c5gshbr");
const gradient = "g9isovl";

require("./Intro.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Intro.tsx");